import * as React from 'react';
import * as _ from 'lodash'
import { Alert, Button, Card, Container, Spinner } from 'react-bootstrap';
import config from '../../../../constants/config';
import { getCurrentUserId } from '../../../../utils/currentUser';


import ButtonLoading from '../../../../components/ButtonLoading/ButtonLoading';
import { JobT } from '../../../../types/Job';
import { initCrewProspects } from '../InitObjectJob';
import { AxiosInstance } from '../../../../utils/RequestMethods';


export type ISignUpJobProps = {
    job: JobT
}

const SignUpJob: React.FC<ISignUpJobProps> = ({ job }) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [crewProspects, setCrewProspects] = React.useState(initCrewProspects);
    const [currentJob, setCurrentJob] = React.useState(null)
    const [isExistsInCrew, setIsExistsInCrew] = React.useState(false);
    const currentUserId = getCurrentUserId()
    React.useEffect(() => {
        if (!_.isEqual(currentJob, job)) {
            fetchData()
            setCurrentJob(job)
        }
        setIsExistsInCrew(getIsExistsInCrew(job))
    }, [job])

    /**
     *
     */
    const fetchData = async () => {
        setIsLoading(true)
        AxiosInstance.get(`${config.url.jobs}/${job.id}/crew-prospects/me`).then((res) => {
            setIsLoading(false)
            if (res && res.data) {
                setCrewProspects(res.data)
            }
        }).catch((error) => {
            setIsLoading(false)
        })
    }

    /**
     *
     */
    const getIsExistsInCrew = (job: JobT): boolean => {
        const crew = job.crew && _.isArray(job.crew) ? job.crew : []
        const find = crew.find((x) => x.id == currentUserId)

        return find ? true : false
    }
    /**
     *
     */
    const signUp = async () => {
        const params = {

        }
        return AxiosInstance.post(`${config.url.jobs}/${job.id}/crew-prospects/me`, params).then((res) => {
            if (res && res.data) {
                setCrewProspects(res.data)
            }
            return 'Sign up for job.';
        })
    }


    /**
     *
     */
    const unSignUp = async () => {
        const params = {

        }
        return AxiosInstance.delete(`${config.url.jobs}/${job.id}/crew-prospects/me`).then((res) => {
            if (res && res.data) {
                setCrewProspects(initCrewProspects)
            }
            return 'Removed from job.';
        })
    }

    if (isLoading) {
        return (
            <Container className="mt-5 text-center">
                <Spinner animation="border" variant="info" />
                Loading ...
            </Container>
        )
    }


    /**
     *
     */
    const renderByStatus = (): JSX.Element => {
        if (getIsExistsInCrew(job)) {
            return (
                <div className='' >
                    <h3 className='text-center alert alert-success'>You are signed up and expected to appear to this job.</h3>
                    <ButtonLoading
                        className='btn-lg'
                        variant="danger"
                        block
                        onClickFetching={unSignUp} >
                        Remove myself from prospects
                    </ButtonLoading>

                </div>
            )

        } else if (crewProspects.status == 'pending' || crewProspects.status == 'rejected') {
            return (
                <div className='' >
                    <h3 className='text-center text-danger'>Pending manager approval for going out on job.</h3>
                    <ButtonLoading
                        className='btn-lg'
                        variant="danger"
                        block
                        onClickFetching={unSignUp} >
                        Remove Myself from Job
                </ButtonLoading>

                </div>
            )

        }
        return (
            <Alert variant={'success'}>
                <p>Place yourself on the Prospect List for this job by clicking the button below.</p>
                <ButtonLoading className='btn-lgx' variant="success"
                    onClickFetching={signUp}>
                    Sign Up for Job
                </ButtonLoading>
            </Alert>
        )


    }

    return (
        <Card className="mb-5x mt-5x" style={{ border: "none" }}>
            <Card.Body>
                {renderByStatus()}
            </Card.Body>
        </Card >
    );
}


export default SignUpJob;
export { SignUpJob };
